import React from 'react';
import { Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import type { TypeFlowMessage } from '@/types/auth/types.auth.flow';

type Props = { message: TypeFlowMessage | null; field?: string };

const FlowAlert: React.FC<Props> = ({ message, field }) => {
    if (!message || (field !== undefined && message.field === field)) return null;
    return (
        <Alert color="red" variant="light" radius="md" icon={<IconAlertCircle size={18} />} role="alert">
            {message.text}
        </Alert>
    );
};

export default FlowAlert;
